import styled from 'styled-components';

export const FlagsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const FlagButton = styled.button`
  width: 32px;
  height: 22px;
  border: 2px solid
    ${(props) => (props.isActive ? "var(--accent)" : "transparent")};
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
  box-shadow: ${(props) =>
    props.isActive ? "var(--shadow-sm)" : "none"};
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-sm);
    border-color: ${(props) =>
      props.isActive ? "var(--accent)" : "var(--border-default)"};
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  @media (max-width: 768px) {
    width: 28px;
    height: 19px;
  }
`;
